<template>
    <div class="team-section">
        <!-- <div @click="receiveHongbao">领红包测试（{{ init_data?.act_data?.is_received ?
            '已领取' : '未领取' }}） {{ reveiveDataFormat }} {{ canReveive }}</div> -->
        <div class="title-box yuyue-text">
            <div class="title"></div>
            <div class="sub-title heiti-text">邀请好友，领限定时装</div>
        </div>
        <div class="postar">
            <div class="tag">5人成团即得</div>
            <div class="name">秋水寒霜时装</div>
            <div class="member_count">当前团队：{{ member_count }}</div>
        </div>
        <!-- <div class="award-box">{{ table_data }}</div> -->
        <div class="award-progress">
            <div class="award-box">
                <div class="award-item" v-for="item in team_award_data" :key="item.award_item"
                    @click="awardHandle(item)">
                    <div class="award-icon" :class="{
                        get: member_count >= item.total_progress
                    }">
                        <div class="img-box">
                            <!-- {{ item.item_id }} -->
                            <Image v-if="!!getIcon(item)" :src="getIcon(item)" :size="{ width: 75, height: 75 }" />
                        </div>
                    </div>
                    <div class="count">{{ item.content }}</div>
                </div>
            </div>
            <div class="progress-box">
                <div class="inner-box" :style="`width: ${progressWidth}vw`"></div>
                <div class="dot-box">
                    <div class="dot-item" :class="{
                        get: member_count >= item.total_progress
                    }" v-for="item in team_award_data" :key="item.award_item"></div>
                </div>
            </div>
        </div>
        <div class="member-box">
            <nut-swiper ref="swiperRef" :is-prevent-default="false" @change="swiperChangeHandle" class="member-swiper">
                <nut-swiper-item class="member-item-box" v-for="(item, index) in memberSwiperList" :key="index">
                    <div class="member-item-info" v-for="it in item" :key="it.user_id" @click="memberClickHandle(it)">
                        <div class="avatar-box" v-if="!!it.avatar">
                            <img :src="it.avatar" alt="">
                        </div>
                    </div>
                </nut-swiper-item>
                <template #page>
                    <div class="swiper-pagination" v-if="pageCount > 1">
                        <!-- {{ currentPage }}/ {{ pageCount }} -->
                        <div class="page-dot" :class="{
                            active: index + 1 === currentPage
                        }" v-for="(item, index) in pageCount" :key="item"></div>
                    </div>
                </template>
            </nut-swiper>
            <div class="invite-box">
                <div class="invite-tip">组队人数≥2时抽奖机会+1</div>
                <div class="btn-box">
                    <TxButton src="anniu_3" class="t-btn group" name="一键入群" @click="showGroupGuideModal">
                        <span>一键入群</span>
                        <div class="qipao">快速组队 领激活码</div>
                    </TxButton>
                    <TxButton src="anniu_2" class="t-btn" name="邀请好友" @click="invitedHandle">邀请好友</TxButton>
                </div>
            </div>
        </div>
    </div>
</template>


<script lang="ts" setup>
import { computed, inject, onMounted, ref, toRaw, watch } from 'vue';
const { table_data, init_data, member_list, team_id, set_member_list, login_status, error_codemsg } = inject('GlobalData');
const { reveiveDataFormat, canReveive, activity_config } = inject('GlobalStore');
const GlobalReporter = inject('GlobalReporter');
import eventEmitter from '@utils/event';
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
const { isWeChat, isMiniProgram } = useWeChatEnv();

const emits = defineEmits(['inviteMember', 'showAwardTip'])

const swiperRef = ref()
const team_award_data = computed(() => table_data.team_award_data || [])

const progressList = computed(() => {
    if (team_award_data.value.length === 0) {
        return []
    }
    const list = toRaw(team_award_data.value)
    console.log('存在数据', list);
    let indic = 54.8 / 3
    let max = 54.8
    // let percentList = [0, 13.33, 28, ]
    const formatList = list.map((item, index) => {
        const percent = index === list.length - 1 ? max : (index * indic)
        return {
            ...item,
            percent
        }
    })
    console.log('formatList', formatList);

    return formatList
})

const member_count = computed(() => init_data?.act_data?.member_count || 0)
// const member_count = computed(() => 5)

const progressWidth = computed(() => {
    // return computeProgressWidth(progressList.value, 3)
    return computeProgressWidth(progressList.value, member_count.value)
})

const currentPage = ref(1)
const pageCount = computed(() => Math.ceil(member_list.value.length / 5))

const memberSwiperList = computed(() => {
    if (member_list.value.length < 1) {
        let itemList = []
        for (let index = 0; index < 5; index++) {
            const emptyMemberInfo = { user_id: `empty${index}`, avatar: '', name: '' }
            itemList.push(emptyMemberInfo)
        }
        return [itemList]
    } else {
        let finalList = []
        // const page = Math.ceil(member_list.value.length / 5) // 页数
        const page = pageCount.value // 页数
        console.log('pagepage', page);

        for (let i = 0; i < page; i++) {
            let itemList = []
            for (let j = 0; j < 5; j++) {
                const tarIndex = (i * 5) + j
                const tar = member_list.value[tarIndex] || { user_id: `empty${tarIndex}`, avatar: '', name: '' }
                itemList.push(tar)
            }
            finalList.push(itemList)
        }
        console.log(finalList, 'finalListfinalList');
        return finalList
    }
    // return [
    //     { user_id: 1 },
    //     { user_id: 2 },
    //     { user_id: 3 },
    // ]
})

watch(() => memberSwiperList.value, () => {
    // currentPage.value = 1
    if (currentPage.value > pageCount.value) {
        currentPage.value = 1
    }
    swiperRef.value?.to(currentPage.value - 1)
}, {
    deep: true
})

watch(() => pageCount.value, (nVal, oldVal) => {
    if (currentPage.value > pageCount.value) {
        currentPage.value = 1
    }
    swiperRef.value?.to(currentPage.value - 1)
})

function computeProgressWidth(list, currentScore = 0) {
    console.log('currentScore', currentScore);

    const cloneList = JSON.parse(JSON.stringify(list))
    if (!cloneList.length) {
        return 0
    }
    const scoresArr = cloneList.map(item => item.total_progress)
    const minVal = Math.min(...scoresArr)
    const maxVal = Math.max(...scoresArr)

    if (currentScore >= maxVal) {
        return cloneList[cloneList.length - 1].percent
    }
    if (currentScore <= 0) {
        return 0
    }

    const findEquallScore = cloneList.find(item => item.total_progress === currentScore)
    if (!!findEquallScore) {
        return findEquallScore.percent
    }

    const findHigherScoreIndex = cloneList.findIndex(item => item.total_progress > currentScore)
    const previousData = cloneList[findHigherScoreIndex - 1] || { total_progress: 0, percent: 0 }
    const lastData = cloneList[findHigherScoreIndex]
    console.log({ lastData, previousData });

    const scorePercent = (currentScore - previousData.total_progress) / (lastData.total_progress - previousData.total_progress)
    const percent = previousData.percent + (lastData.percent - previousData.percent) * scorePercent
    return percent
}

// test()
function test() {
    setTimeout(() => {
        set_member_list([
            {
                "user_id": "yetaize3@163.com1",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com2",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com3",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com4",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com5",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com6",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com7",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com8",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
        ])
    }, 5000)
}

// test2()
function test2() {
    setTimeout(() => {
        set_member_list([
            {
                "user_id": "yetaize3@163.com1",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com2",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com3",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com4",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com5",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com6",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com7",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com8",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com9",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com10",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
            {
                "user_id": "yetaize3@163.com11",
                "name": "星",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKHrcLlQj9HEVIva2uu3qWAhc9ZanZIBIAA0ca6R5CHccSZXticUuRvUdqIyzDHelSuKBewbvcCR7A/132"
            },
            {
                "user_id": "wywengmankai@163.com12",
                "name": "啊铠",
                "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEKK5CIvAFFR1I2tubGQupeMy8KTMDrvYOXW5zbYVTCSy3icN4H2jxWPA0dC91Jypk5YBmgNz8GKvGYibicic2TibeWTSYnSDyy7hxuvY4osiaCU368g/132"
            },
        ])
    }, 15000)
}



function swiperChangeHandle(val: number) {
    currentPage.value = val + 1
}

function beforeCheck() {
    if (!(isMiniProgram.value || isWeChat.value)) {
        // eventEmitter.emit('toast', {
        //     text: '请使用微信打开此活动',
        //     duration: 2,
        // });
        eventEmitter.emit('showCommomTipModal', 'copyLink');
        return false
    }
    if (!login_status.value) {
        eventEmitter.emit('login');
        return false
    }
    if (!!error_codemsg.value) {
        console.log(error_codemsg.value, '这里的问题')
        eventEmitter.emit('toast', {
            text: error_codemsg.value,
        });
        return false
    }
    return true
}

function invitedHandle() {
    eventEmitter.emit('toast', {
    text: '活动已过期',
  });
  return 

    const ispass = beforeCheck()
    if (!ispass) return
    emits("inviteMember")
}

function showGroupGuideModal() {
    eventEmitter.emit('showGroupGuideModal');
}

function receiveHongbao() {
    const ispass = beforeCheck()
    if (!ispass) return
    eventEmitter.emit('showHongbaoModal');
}

function awardHandle(item: any) {
    // console.log(item.item_id);
    if (!!item?.item_id) {
        emits("showAwardTip", item.item_id)
    }
}

function memberClickHandle(item: any) {
    const reg = /^empty\d+$/; // 是否是真实用户
    if (reg.test(item.user_id)) {
        GlobalReporter.add({ btn_name: '拉人赢好礼' });
        invitedHandle()
    }
}

function getIcon(item) {
    return activity_config.value.item_data?.[item.item_id]?.icon
}


</script>

<style lang="scss" scoped>
.yuyue-text {
    color: #aabfca;
    font-size: 3.6vw;
    font-family: "KaiTi", "楷体", serif;
}

.heiti-text {
    color: #aabfca;
    font-size: 3.6vw;
    font-family: "SimHei", "黑体", serif;
}

.team-section {
    font-size: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;

    .title-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 80px;

        .title {
            // font-size: 47px;
            // background: linear-gradient(180deg, #ffffff 0%, #ffffff 10%, #9fd3eb 70%, #9fd3eb 100%);
            // color: transparent;
            // background-clip: text;
            @include bg(3)
        }

        .sub-title {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #65778B;

            &::before {
                content: '';
                @include bg('xian');
                margin-right: 10px;
            }

            &::after {
                content: '';
                @include bg('xian');
                transform: rotateY(180deg);
                margin-left: 10px;
            }
        }
    }

    .postar {
        position: relative;
        @include bg('renwu');

        .tag {
            position: absolute;
            left: 150px;
            top: 20px;
            @include bg('btkq');
            writing-mode: vertical-rl;
            font-size: 17px;
            color: #dfc184;
            text-orientation: upright;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .name {
            position: absolute;
            left: 50%;
            bottom: 120px;
            transform: translate(-50%, 0);
            @include bg('db_2');
            font-size: 20px;
            color: #a2b0bd;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .member_count {
            position: absolute;
            left: 50%;
            bottom: 10px;
            transform: translate(-50%, 0);
            @include bg('db_3');
            font-size: 20px;
            color: #a2b0bd;
            display: flex;
            justify-content: center;
            align-items: center;
        }

    }

    .award-progress {
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .award-box {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 20px;
            color: #fff;
            width: calc(411px + 91px);
            z-index: 2;

            .award-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                width: 81px;

                .award-icon {
                    // @include bg('baoxiang_1');
                    @include bg('jpdi');
                    width: 91px !important;
                    height: 91px !important;
                    background-size: 81px 81px;
                    background-position: center top;
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    box-sizing: border-box;
                    padding-top: 3px;

                    // &.get {
                    //     @include bg('baoxiang');
                    // }

                    .img-box {
                        width: 75px;
                        height: 75px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .count {
                    @include bg('db_4');
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

        }

        .progress-box {
            position: relative;
            @include bg('jdt');
            height: 15px;
            z-index: 1;
            pointer-events: none;
            margin-top: -40px;

            .inner-box {
                @include bg('jdt_2');
                background-size: 411px 3px;
                background-position: 0 0;
            }

            .dot-box {
                width: calc(411px + 26px);
                position: absolute;
                left: 50%;
                top: 0;
                transform: translate(-50%, 0);
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .dot-item {
                    @include bg('dian');

                    &.get {
                        @include bg('dian_2');
                    }
                }
            }
        }
    }


    .member-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 50px;

        .member-swiper {
            position: relative;
            width: calc(87px * 5 + 30px * 4);

            .member-item-box {
                width: 100%;
                padding-bottom: 40px;
                // background-color: #acf;
                display: flex;
                align-items: center;

                .member-item-info {
                    @include bg('jiahao');
                    margin-right: 30px;

                    &:last-child {
                        margin-right: 0;
                    }

                    .avatar-box {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 86%;
                            height: 86%;
                            border-radius: 50%;
                        }
                    }
                }
            }

            .swiper-pagination {
                position: absolute;
                left: 50%;
                bottom: 0;
                transform: translate(-50%, 0);
                display: flex;
                align-items: center;

                .page-dot {
                    @include bg('dian_3');

                    &:last-child {
                        margin-right: 0;
                    }

                    &.active {
                        @include bg('dian_4');
                    }
                }
            }
        }
    }

    .invite-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        .invite-tip {
            font-size: 20px;
            color: #65778B;
            margin-bottom: 25px;
        }

        .btn-box {
            .group {
                position: relative;
                margin-right: 20px;

                .qipao {
                    position: absolute;
                    content: '';
                    @include bg('qipao');
                    right: -10px;
                    top: -25px;
                    font-size: 16px;
                    font-weight: normal;
                    color: #fff;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    box-sizing: border-box;
                    padding-bottom: 3px;
                    pointer-events: none;
                    padding-right: 10px;
                }
            }
        }
    }
}
</style>